export default __webpack_public_path__ + "static/ola-4f1561b58ba855efe04a477e620d85ab.png";